import React from "react";

export const IndexLabel = ({ ind }) => {
  return (
    <div>
      <h4>{ind + 1}</h4>
    </div>
  );
};
